import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUserChannels } from '../../../api/users';

import { PERMISSION_NAMES } from '../../../constants/permissionNames';
import { REQUEST } from '../../../constants/request';

export const fetchThreadChannels = createAsyncThunk(
  'currentUser/fetchThreadChannels',
  async (params, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getUserChannels({
        params: {
          withToken: PERMISSION_NAMES.STREAMITEM_THREAD_CREATE,
        },
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (param, { getState }) => {
      const currentLoading =
        getState().currentUser.currentLoadings?.fetchRebuzzChannels ||
        REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchThreadChannelsExtraReducers = builder => {
  builder
    .addCase(fetchThreadChannels.pending, (state, { meta }) => {
      state.currentLoadings.fetchThreadChannels = REQUEST.pending;
      state.currentRequestIds.fetchThreadChannels = meta.requestId;
    })
    .addCase(fetchThreadChannels.fulfilled, (state, { meta, payload }) => {
      if (
        state.currentLoadings.fetchThreadChannels === REQUEST.pending &&
        state.currentRequestIds.fetchThreadChannels === meta.requestId
      ) {
        const channelsCIDs = payload.map(
          channel => `${channel.orgId}/${channel.streamId}/${channel.id}`,
        );
        state.threadChannels = [...channelsCIDs];
        state.currentLoadings.fetchThreadChannels = REQUEST.idle;
        state.currentRequestIds.fetchThreadChannels = undefined;
      }
    })
    .addCase(fetchThreadChannels.rejected, (state, { error }) => {
      state.currentLoadings.fetchThreadChannels = REQUEST.idle;
      state.currentRequestIds.fetchThreadChannels = undefined;
      state.currentErrors.fetchThreadChannels = error;
    });
};
